import React, { useEffect } from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import './style.scss';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import TopBar from 'scenes/HomePatient2/TopBar';
import { useAppSelector } from 'careand-redux/store';
import { useQueryParams } from 'components/Navigation/NavStack';
import EntryView from './view';
import { getTenantIdentity } from 'hooks/useTenantIdentity';
import { TenantAsset } from '../../../careand-redux/selectors';
import TenantImg from '../../../components/TenantImg';

const PatientEntry = () => {
  const nav = useNavStack(Stacks.Master);
  const isLoggedIn = useAppSelector((state) => state.authentication.loggedIn);
  const clientRole = useAppSelector((state) => state.device.clientRole);
  const params = useQueryParams() as { link?: string };
  const isLinking = params?.link === 'true';

  useEffect(() => {
    if (isLoggedIn && !isLinking) {
      nav.popTo('/');
    }
  }, []);

  function onLogin() {
    let url = '/login';
    if (isLinking) {
      url += '?link=true';
    }
    nav.push(url);
  }

  function onRegister() {
    nav.push('/register');
  }

  return (
    <EntryView className="entry" topContent={isLoggedIn && <TopBar title="Link Account" />}>
      <TenantImg src="logo_full_color" alt={getTenantIdentity().name} className="logo" />
      <div className="buttons">
        <DefaultButton name="Sign In" onClick={onLogin} />
        {clientRole !== 'team' && (
          <DefaultButton className="light" name="Create an Account" onClick={onRegister} />
        )}
      </div>
    </EntryView>
  );
};

export default PatientEntry;
